import { render, staticRenderFns } from "./EmployeePageHeader.vue?vue&type=template&id=44998cb0"
import script from "./EmployeePageHeader.vue?vue&type=script&lang=js"
export * from "./EmployeePageHeader.vue?vue&type=script&lang=js"
import style0 from "./EmployeePageHeader.vue?vue&type=style&index=0&id=44998cb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports